import { createFeatureSelector } from '@ngrx/store';

import * as fromMapControl from './map-control.reducer';

export const selectMapControlState = createFeatureSelector<fromMapControl.MapControlState>(
  fromMapControl.mapControlFeatureKey
);
